export default __webpack_public_path__ + "static/saratov-1f5fe10ad7b81a4f24ca85aa753fa78c.jpg";